import React, {createContext,useReducer,useContext} from "react";
import {rootReducer,initialAppState} from "./rootReducer";

const AppStateContext = createContext();
const AppDispatchContext = createContext();

export const AppStateProvider = ({children}) => {
    const [state, dispatch] = useReducer(rootReducer, initialAppState);
    return (
        <AppStateContext.Provider value={state}>
            <AppDispatchContext.Provider value={dispatch}>
                {children}
            </AppDispatchContext.Provider>
        </AppStateContext.Provider>
    );
}

export const useAppState = () => useContext(AppStateContext);
export const useAppDispatch = () => useContext(AppDispatchContext);